import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ToastsManager, Toast } from 'ng2-toastr';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { Json2csvService } from '../../../services/json2csv.service';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';
import { ApprovalService } from '../../../services/approval.service';
import { Approval } from '../../../models/Approval.model';
import { ManualApproval } from '../../../models/ApprovalManual.model';
import * as _ from "lodash";

@Component({
    selector: 'app-approvals-upload',
    templateUrl: './approvals-upload.component.html',
    styleUrls: ['./approvals-upload.component.scss']
})
export class ApprovalsUploadComponent implements OnInit {
    @ViewChild('uploadInput') uploadInput:ElementRef;
    commonHelper: CommonHelper = new CommonHelper();
    loading: boolean;
    selectedFile: FileList;
    approvalsValid: boolean;
    integrationExecuted: boolean = false;
    approvals = [];
    overrideValues = false;

    constructor(
        private toast: ToastsManager,
        private errorHandler: ErrorHandlerProvider,
        private json2csvService: Json2csvService,
        private approvalService: ApprovalService,
    ) { }

    async ngOnInit() {
        this.loading = false;
    }

    async processFile() {
        this.approvals = [];
        this.integrationExecuted = false;

        if (!this.selectedFile || this.selectedFile.length == 0)
            return this.toast.warning('Para fazer o processamento, é necessário selecionar um arquivo');

        try {
            this.loading = true;

            const file = this.selectedFile.item(0);
            const responseProcess = await this.approvalService.convertApprovalsCsvToJson(file, this.overrideValues);
            this.loading = false;

            if(responseProcess.status && responseProcess.status == 500) {
                this.errorHandler.interceptError(responseProcess, 'Carga de aprovações');
                return;
            }

            this.approvals = responseProcess;
            if(this.approvals && this.approvals.length > 0) {
                this.approvals = this.approvals.map(approval => {
                    return {
                        ignoreIntegration: false,
                        active: true,
                        ...approval
                    }
                });

                this.checkProcessedApprovals();
                
                this.toast.info(
                    "Atenção: Só será permitido a integração de aprovações com processamento válido. " +
                    "Em casos de alguma aprovação ser inválida, descarte-o na coluna 'Ações' ou corrija e processe " +
                    "novamente o arquivo de carga", '',
                    { dismiss: 'controlled' }
                ).then((t: Toast) => { setTimeout(() => { this.toast.dismissToast(t) }, 9000) })
            }

        } catch (error) {
            this.loading = false;
            this.errorHandler.interceptError(error, 'Carga de aprovações');
        }
    }

    async integrate() {
        try {
            this.loading = true;

            const approvalsValid = this.approvals.filter(approval =>
                !approval.ignoreIntegration && approval.result.success
            );

            if(approvalsValid.length == 0)
                return this.toast.warning('Não há nenhuma aprovação valido a ser integração', 'Erro na integração');

            let approvalsModel = new Array<Approval>();
            for (let a of approvalsValid) {
                let newApproval: Approval = new Approval();
                newApproval.projects = [];
                newApproval.manualApproval = new ManualApproval();
                newApproval.loadFromServer(a);
                newApproval.approvedHours = newApproval.realizedHours;
                newApproval.manualApproval.byUpload = true;
                newApproval.valueChangedByUpload = this.overrideValues;
                approvalsModel.push(newApproval);
            }
            let approvalSuccess = 0, approvalError = 0;
            let responseApprovals = await this.approvalService.create(approvalsModel);

            this.loading = false;
            if (responseApprovals && responseApprovals.length > 0) {
                for (let approval of responseApprovals) {
                    if (approval && approval.success)
                        approvalSuccess++;
                    else
                        approvalError++;
                }

                if(approvalSuccess)
                    this.toast.success(`${approvalSuccess} aprovações integradas com sucesso`, 'Operação finalizada', {
                        toastLife: 5000,
                        showCloseButton: true
                    });
                if(approvalError)
                    this.toast.warning(`Erro ao integrar ${approvalError} aprovações`, 'Operação finalizada', {
                        toastLife: 5000,
                        showCloseButton: true
                    });
            }
            this.approvals = [];
            this.selectedFile = null;
            this.overrideValues = false;
            if(this.uploadInput) this.uploadInput.nativeElement.value = '';
        } catch (error) {
            this.loading = false;
            this.errorHandler.interceptError(error, 'Carga de aprovações');
        }
    }

    selectFile(event) {
        this.selectedFile = event.target.files;
    }

    remove(index) {
        this.approvals[index].ignoreIntegration = true;
        this.checkProcessedApprovals();
    }

    checkProcessedApprovals() {
        const invalidApproval = this.approvals.some(approval =>
            !approval.ignoreIntegration && !approval.result.success
        );

        if (this.approvals.length == 0 ||
            this.approvals.every(approval => approval.ignoreIntegration) ||
            invalidApproval){
            this.approvalsValid = false;
        } else {
            this.approvalsValid = true;
        }
    }

    downloadCsvTemplate() {
        const fields = [
            'CPF',
            'NOME',
            'HORAS TOTAIS',
            'VALOR GERENCIAL',
            'VALOR CONTABIL',
            'COMPETENCIA_MES',
            'COMPETENCIA_ANO'
        ];

        this.json2csvService.export(
            [ fields.reduce((acc, field) => ({ ...acc, [field]: '' }), {}) ],
            'Modelo de Carga de aprovação',
            true
        );
    }

    onOverrideToggleChange() {
        this.approvals = [];
        this.selectedFile = null;
        this.approvalsValid = false;
        this.uploadInput.nativeElement.value = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/views/approvals/approvals-upload/approvals-upload.component.ts